import React from 'react';
import { Text, RichText, Image } from '@sitecore-jss/sitecore-jss-react';
import './style.scss';
import SingleIconItem from './SingleIconItem';
import ButtonsContainer from '../Shared/components/ButtonsContainer';
import GenericPlaceholder from '../Shared/components/GenericPlaceholder/index.js';
import clsx from 'clsx';

const InPageBanner = ({ fields, params }) => {
  if (!fields) return <GenericPlaceholder componentName="InPageBanner" />;
  const {
    text,
    iconslist,
    backgroundImage,
    mobileBackgroundImage,
    backgroundColor,
    items: link,
    heading,
  } = fields;
  const shouldRenderDescription = !!text?.value;
  const shouldRenderIconList = Array.isArray(iconslist) && iconslist.length > 0;
  const shouldRenderImage = !!backgroundImage?.value?.src;
  const shouldRenderMobileBackgroundImage = !!mobileBackgroundImage?.value?.src;
  const shouldRenderTitle = !!heading?.value;
  const shouldRenderBackgroundColor = !!backgroundColor?.value;

  const isEliteTheme = fields?.IsEliteTheme?.value;
  return (
    <div
      className={clsx(
        'in-page__banner',
        isEliteTheme ? 'theme-elite' : 'theme-default',
        'add-margins',
        params?.Styles
      )}
      style={shouldRenderBackgroundColor ? { background: backgroundColor?.value } : null}
    >
      {shouldRenderImage && (
        <div className="in-page__banner-bg d-none d-md-block">
          <figure>
            <Image field={backgroundImage} />
          </figure>
        </div>
      )}
      {shouldRenderMobileBackgroundImage ? (
        <div className="in-page__banner-bg d-block d-md-none">
          <figure>
            <Image field={mobileBackgroundImage} />
          </figure>
        </div>
      ) : (
        shouldRenderImage && (
          <div className="in-page__banner-bg d-block d-md-none">
            <figure>
              <Image field={backgroundImage} />
            </figure>
          </div>
        )
      )}
      <div className="row in-page__banner-content content">
        <div className="col-12 col-md-7 in-page__banner-content_left">
          {shouldRenderTitle && (
            <div className="in-page__banner-content_left-title">
              <Text field={heading} />
            </div>
          )}
          {shouldRenderDescription && (
            <RichText className="in-page__banner-content_left-desc" field={text} />
          )}
          <ButtonsContainer items={link} className="in-page__wrapButtons" />
        </div>
        {shouldRenderIconList && (
          <div className="col-12 col-md-5 in-page__banner-content_right">
            {iconslist.map((item, index) => {
              return <SingleIconItem key={index} data={item.fields} />;
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default InPageBanner;
